import React from 'react';

const LanguageListing = ({ data, isLoading, searchQuery }) => {
    return (
        <div
            className="table-card"
            style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                paddingBottom: '10px'
            }}
        >
            <table className="custom-table" style={{ minWidth: '700px' }}>
                <thead>
                    <tr>
                        <th width="10%" style={{ textAlign: 'center' }}>STT</th>
                        <th width="35%">TÊN NGOẠI NGỮ (VN)</th>
                        <th width="35%">TÊN NGOẠI NGỮ (EN)</th>
                        <th width="20%" style={{ textAlign: 'center' }}>MÃ (ISO 639-1)</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center', padding: '60px', color: '#003399' }}>
                                <i className="fa-solid fa-circle-notch fa-spin" style={{ fontSize: '35px', marginBottom: '15px', display: 'block' }}></i>
                                Đang nạp thư viện ngôn ngữ toàn cầu
                            </td>
                        </tr>
                    ) : data.length === 0 ? (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center', padding: '50px', color: '#888' }}>
                                <i className="fa-solid fa-magnifying-glass-minus" style={{ fontSize: '30px', display: 'block', marginBottom: '15px', color: '#ccc' }}></i>
                                Không tìm thấy ngôn ngữ nào trùng khớp
                            </td>
                        </tr>
                    ) : (
                        data.map((item, index) => (
                            <tr key={item.code}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ fontWeight: '600', color: '#333' }}>{item.nameVi}</td>
                                <td style={{ color: '#666' }}>{item.nameEn}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <span style={{
                                        background: '#e8f5e9',
                                        color: '#2e7d32',
                                        padding: '4px 12px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        border: '1px solid #c8e6c9',
                                        textTransform: 'uppercase'
                                    }}>
                                        {item.code}
                                    </span>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default LanguageListing;